import React from 'react';
import { LogOut } from 'lucide-react';
import { Button } from '../ui/button';

export const AdminDashboardHeader = ({
  lastActionMessage,
  recreatingSample,
  onRecreateSampleData,
  onLogout,
}) => {
  return (
    <header className="bg-white border-b sticky top-0 z-10">
      <div className="container mx-auto px-4 py-4">
        <div className="flex flex-col gap-2 md:flex-row md:items-center md:justify-between">
          <div>
            <div className="flex items-center gap-3">
              <img
                src="/assets/logo-mi-web-vacacional-icon.png"
                alt="Mi Web Vacacional"
                className="h-10 w-10 object-contain flex-shrink-0"
              />
              <h1 className="text-2xl font-bold">Panel de Administracion</h1>
            </div>
            {lastActionMessage && (
              <p className="text-sm text-gray-600 mt-1">Ultima accion: {lastActionMessage}</p>
            )}
          </div>
          <div className="flex items-center gap-2">
            <Button
              variant="secondary"
              onClick={onRecreateSampleData}
              disabled={recreatingSample}
            >
              {recreatingSample ? 'Recreando...' : 'Recrear Datos de Muestra'}
            </Button>
            <Button variant="outline" onClick={onLogout}>
              <LogOut className="h-4 w-4 mr-2" />
              Cerrar sesion
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};
